import "devextreme/dist/css/dx.common.css";
import "devextreme/dist/css/dx.light.css";
import React, {useContext, useEffect } from "react";
import Users from "./views/Users";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
  useLocation
} from "react-router-dom";
import "./css/custom.css";
import Projects from "./views/Projects";
import Boards from "./views/Boards";
import EditProject from "./views/EditProject";
import PlanningBoard from "./views/PlanningBoard";
import HvProject from "./views/HvProject";
import Login from "./views/Login";
import HvAgile from "./views/HvAgile";
import Tasks from "./views/Tasks";
import Tags from "./views/Tags";
import Productivity from "./views/Productivity";
/* import { Component } from "react"; */
import EditTemplate from "./views/EditTemplate";
import SprintBoard from "./views/SprintBoard";
import ScheduleTraditional from "./views/ScheduleTraditional";
import KanbanBoard from "./views/KanbanBoard";
import Helps from "./views/Helps";
import Landing from "./views/Landing";
import TraditionalFiles from "./views/TraditionalFiles";
import ReactGA from "react-ga4"
import GanttTest from "./components/GanttDx/GanttTest";
import config from "devextreme/core/config";
import DasboardPharos from "./views/DasboardPharos";
import RiskClientOportunity from "./views/RiskClientOpportunity";
import DashboardClusterPharos from "./views/DashboardClusterPharos";
import AuthCallback from "./views/AuthCallback";

config({
  licenseKey: process.env.REACT_APP_LICENSE_KEY_DEVEXTREME
})

/* import WelcomeModal from "./components/WelcomeModal"; */

const PrivateRoute = ({ component: Component, ...rest }) => {
  const auth = localStorage.getItem("tokenuserid");
/*   const isAuth = authState.isAuthenticated */
  return (
    <Route
      {...rest}
      render={(props) =>
        auth ? <Component {...props} /> : <Redirect to={{ pathname: "/" }} />
      }
    />
  );
};

const IsLogged = ({ component: Component, ...rest }) => {
  const auth = localStorage.getItem("tokenuserid");
  return (
    <Route
      {...rest}
      render={(props) =>
        auth ? (
          <Redirect to={{ pathname: "/tasks" }} />
        ) : (
          <Component {...props} />
        )
      }
    />
  );
};


const usePageViews = () => {
  let location = useLocation();
  
  useEffect(()=> {
    if(!window.GA_INITIALIZED){
       ReactGA.initialize("G-P63XMR3JJK")
       window.GA_INITIALIZED = true
    }
    let titlePageName = location.pathname?.split('/')
    let titlePage = titlePageName[1]
    ReactGA.set({page: location.pathname})
    ReactGA.send({hitType:"pageview", page : location.pathname, title:titlePage})

  },[location])
}

function App() {


  usePageViews()
  return (
    <div className="App">
    {/*   <Router> */}
        <Switch>
          <PrivateRoute path="/resources" component={Users} />
          <PrivateRoute path="/projects/:idView?" component={Projects} />
          <PrivateRoute path="/landing" component={Landing} />
          <PrivateRoute path="/boards" component={Boards} />
          <PrivateRoute path="/project/:uid" component={EditProject} />
          <PrivateRoute path="/project" component={EditProject} />
          <PrivateRoute path="/template/:uid" component={EditTemplate} />
          <PrivateRoute path="/template" component={EditTemplate} />
          <PrivateRoute path="/schedule/:uid" component={ScheduleTraditional} />
          <PrivateRoute path="/planning-board/:uid" component={PlanningBoard} />
          <PrivateRoute path="/sprint-board/:uid" component={SprintBoard} />
          <PrivateRoute path="/kanban-board/:projectId/:sprintId" component={KanbanBoard} />
          <PrivateRoute path="/hv-project/:uid" component={HvProject} />
          <PrivateRoute path="/files-project/:uid" component={TraditionalFiles} />
          <PrivateRoute path="/hv-agile/:uid" component={HvAgile} />
          <PrivateRoute path="/tasks" component={Tasks} />
             {/*Iniciatives Routes */}

          <PrivateRoute path="/tags/:uid" component={Tags} />
          <PrivateRoute path="/productivity" component={Productivity} />
          <PrivateRoute path="/gantt" component={GanttTest} />
          <PrivateRoute path="/helps" component={Helps} />
          <PrivateRoute path="/pharos-dashboard/" component={DasboardPharos} />
          <PrivateRoute path="/pharos-cluster-dashboard/:Cluster/:IdCluster" component={DashboardClusterPharos} />

        {/*RUTA FORMULARIO REGISTRO RIESGO */}
        <PrivateRoute path="/risk-request" component={RiskClientOportunity} />

          {/* Ruta pública para el callback de Microsoft Entra ID */}
          <Route exact path="/auth/callback" component={AuthCallback} />

          <IsLogged path="/" component={Login} />
          {/* <Route path="/">
            <Login />
          </Route> */}
        </Switch>
     {/*  </Router> */}
    </div>
  );
}

export default App;
